module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-nicklist"
  }, [_c('div', {
    staticClass: "kiwi-nicklist-info"
  }, [_vm._v(_vm._s(_vm.$t('person', {
    count: _vm.sortedUsers.length
  })))]), _vm._v(" "), _c('ul', {
    staticClass: "kiwi-nicklist-users"
  }, _vm._l((_vm.sortedUsers), function(user) {
    return _c('li', {
      key: user.nick,
      staticClass: "kiwi-nicklist-user",
      class: [
        _vm.userMode(user) ? 'kiwi-nicklist-user--mode-' + _vm.userMode(user) : '',
        user.away ? 'kiwi-nicklist-user--away' : ''
      ]
    }, [_c('span', {
      staticClass: "kiwi-nicklist-user-prefix"
    }, [_vm._v(_vm._s(_vm.userModePrefix(user)))]), _c('span', {
      staticClass: "kiwi-nicklist-user-nick",
      style: (_vm.nickStyle(user.nick)),
      on: {
        "click": function($event) {
          _vm.openUserbox(user, $event)
        }
      }
    }, [_vm._v(_vm._s(user.nick))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac053d68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nicklist.vue
// module id = 505
// module chunks = 2